export default {"src":"/_next/static/media/nodejs.a47945b0.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};